<app-page-modifications>
  <app-header class="full-width"></app-header>
  <main id="content" class="js-content" role="main">
    <div class="grid-row">
      <div class="column-full">
        <p class="aa-lead-size"  tabindex="0">
         Choose colour of page
        </p>
        <div class="grid-row">
          <div class="column-float">
            <fieldset>
              <div class="multiple-choice" *ngFor="let contrastSetting of contrastSettings">
                <input type="radio"
                        value="{{contrastSetting.val}}"
                        id="contrast-{{contrastSetting.val}}"
                        name="colour-contrast"
                        [checked]="selectedContrast === contrastSetting.val"
                        (change)="selectionChange(contrastSetting.val)">
                <label for="contrast-{{contrastSetting.val}}"><span class="aa-contrast-{{contrastSetting.val}} aa-copy-size {{accessArrangements.fontSize}}">{{contrastSetting.label}}</span></label>
              </div>
            </fieldset>
          </div>
          <div class="column-float" aria-hidden="true">
            <div class="preview-box aa-contrast-{{selectedContrast}} aa-contrast-border-{{selectedContrast}} {{accessArrangements.fontSize}}">
              <div class="badge aa-copy-size aa-contrast-invert-{{selectedContrast}}">Colour preview</div>
              <div class="preview-content">
                <div class="question-text aa-question-size"><span>123</span></div>
                <table>
                  <tr>
                    <td><button class="numpad-button aa-contrast-invert-{{selectedContrast}}" type="button" tabindex="-1"><span>1</span></button></td>
                    <td><button class="numpad-button aa-contrast-invert-{{selectedContrast}}" type="button" tabindex="-1"><span>2</span></button></td>
                    <td><button class="numpad-button aa-contrast-invert-{{selectedContrast}}" type="button" tabindex="-1"><span>3</span></button></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <p class="aa-copy-size" tabindex="0">
          If you don’t need this setting, please tell your teacher and <a routerLink="/sign-out" >sign out</a>.
        </p>
        <button class="button aa-button-size  aa-contrast-button" (click)="onClick()" id="next">Next</button>
      </div>
    </div>
  </main>
</app-page-modifications>
